// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IOcrDetailsDto } from './IOcrDetailsDto';
import {
    IOcrDetailsDtoFromJSON,
    IOcrDetailsDtoFromJSONTyped,
    IOcrDetailsDtoToJSON,
    IOcrDetailsDtoToJSONTyped,
} from './IOcrDetailsDto';
import type { IClaimApprovalStatusAggregatorDto } from './IClaimApprovalStatusAggregatorDto';
import {
    IClaimApprovalStatusAggregatorDtoFromJSON,
    IClaimApprovalStatusAggregatorDtoFromJSONTyped,
    IClaimApprovalStatusAggregatorDtoToJSON,
    IClaimApprovalStatusAggregatorDtoToJSONTyped,
} from './IClaimApprovalStatusAggregatorDto';
import type { IClaimInternalNoteResponseDto } from './IClaimInternalNoteResponseDto';
import {
    IClaimInternalNoteResponseDtoFromJSON,
    IClaimInternalNoteResponseDtoFromJSONTyped,
    IClaimInternalNoteResponseDtoToJSON,
    IClaimInternalNoteResponseDtoToJSONTyped,
} from './IClaimInternalNoteResponseDto';
import type { IClaimPostingInfoDto } from './IClaimPostingInfoDto';
import {
    IClaimPostingInfoDtoFromJSON,
    IClaimPostingInfoDtoFromJSONTyped,
    IClaimPostingInfoDtoToJSON,
    IClaimPostingInfoDtoToJSONTyped,
} from './IClaimPostingInfoDto';
import type { IClaimTransferInfoDto } from './IClaimTransferInfoDto';
import {
    IClaimTransferInfoDtoFromJSON,
    IClaimTransferInfoDtoFromJSONTyped,
    IClaimTransferInfoDtoToJSON,
    IClaimTransferInfoDtoToJSONTyped,
} from './IClaimTransferInfoDto';
import type { ILetterOfMedicalNecessityDto } from './ILetterOfMedicalNecessityDto';
import {
    ILetterOfMedicalNecessityDtoFromJSON,
    ILetterOfMedicalNecessityDtoFromJSONTyped,
    ILetterOfMedicalNecessityDtoToJSON,
    ILetterOfMedicalNecessityDtoToJSONTyped,
} from './ILetterOfMedicalNecessityDto';
import type { IClaimStatusDto } from './IClaimStatusDto';
import {
    IClaimStatusDtoFromJSON,
    IClaimStatusDtoFromJSONTyped,
    IClaimStatusDtoToJSON,
    IClaimStatusDtoToJSONTyped,
} from './IClaimStatusDto';
import type { IServiceDto } from './IServiceDto';
import {
    IServiceDtoFromJSON,
    IServiceDtoFromJSONTyped,
    IServiceDtoToJSON,
    IServiceDtoToJSONTyped,
} from './IServiceDto';
import type { IClaimEscalationNoteResponseDto } from './IClaimEscalationNoteResponseDto';
import {
    IClaimEscalationNoteResponseDtoFromJSON,
    IClaimEscalationNoteResponseDtoFromJSONTyped,
    IClaimEscalationNoteResponseDtoToJSON,
    IClaimEscalationNoteResponseDtoToJSONTyped,
} from './IClaimEscalationNoteResponseDto';
import type { IEmployeeInfoAggregatorDto } from './IEmployeeInfoAggregatorDto';
import {
    IEmployeeInfoAggregatorDtoFromJSON,
    IEmployeeInfoAggregatorDtoFromJSONTyped,
    IEmployeeInfoAggregatorDtoToJSON,
    IEmployeeInfoAggregatorDtoToJSONTyped,
} from './IEmployeeInfoAggregatorDto';
import type { IOrganizationClaimNoteDto } from './IOrganizationClaimNoteDto';
import {
    IOrganizationClaimNoteDtoFromJSON,
    IOrganizationClaimNoteDtoFromJSONTyped,
    IOrganizationClaimNoteDtoToJSON,
    IOrganizationClaimNoteDtoToJSONTyped,
} from './IOrganizationClaimNoteDto';
import type { IClaimActorAggregatorDto } from './IClaimActorAggregatorDto';
import {
    IClaimActorAggregatorDtoFromJSON,
    IClaimActorAggregatorDtoFromJSONTyped,
    IClaimActorAggregatorDtoToJSON,
    IClaimActorAggregatorDtoToJSONTyped,
} from './IClaimActorAggregatorDto';
import type { IClaimAppealDto } from './IClaimAppealDto';
import {
    IClaimAppealDtoFromJSON,
    IClaimAppealDtoFromJSONTyped,
    IClaimAppealDtoToJSON,
    IClaimAppealDtoToJSONTyped,
} from './IClaimAppealDto';
import type { IClaimProcessingStatusDto } from './IClaimProcessingStatusDto';
import {
    IClaimProcessingStatusDtoFromJSON,
    IClaimProcessingStatusDtoFromJSONTyped,
    IClaimProcessingStatusDtoToJSON,
    IClaimProcessingStatusDtoToJSONTyped,
} from './IClaimProcessingStatusDto';

/**
 * 
 * @export
 * @interface IClaimInfoAggregatorResponseDto
 */
export interface IClaimInfoAggregatorResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    payment_type?: IClaimInfoAggregatorResponseDtoPaymentTypeEnum;
    /**
     * 
     * @type {IServiceDto}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    service?: IServiceDto;
    /**
     * 
     * @type {IOcrDetailsDto}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    ocr_details?: IOcrDetailsDto;
    /**
     * 
     * @type {Array<IClaimStatusDto>}
     * @memberof IClaimInfoAggregatorResponseDto
     * @deprecated
     */
    claim_status_dtos?: Array<IClaimStatusDto>;
    /**
     * 
     * @type {Array<IClaimApprovalStatusAggregatorDto>}
     * @memberof IClaimInfoAggregatorResponseDto
     * @deprecated
     */
    claim_approval_status_dtos?: Array<IClaimApprovalStatusAggregatorDto>;
    /**
     * 
     * @type {Array<IClaimProcessingStatusDto>}
     * @memberof IClaimInfoAggregatorResponseDto
     * @deprecated
     */
    claim_processing_status_dtos?: Array<IClaimProcessingStatusDto>;
    /**
     * 
     * @type {number}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    requested_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    approved_amount?: number;
    /**
     * 
     * @type {Date}
     * @memberof IClaimInfoAggregatorResponseDto
     * @deprecated
     */
    service_on?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    local_date_service_on?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    created_at?: Date;
    /**
     * 
     * @type {IClaimActorAggregatorDto}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    created_by?: IClaimActorAggregatorDto;
    /**
     * 
     * @type {IClaimActorAggregatorDto}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    service_for?: IClaimActorAggregatorDto;
    /**
     * 
     * @type {IClaimActorAggregatorDto}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    assignee?: IClaimActorAggregatorDto;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    organization_path?: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    document_id?: number;
    /**
     * 
     * @type {Array<IClaimInternalNoteResponseDto>}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    claim_internal_notes?: Array<IClaimInternalNoteResponseDto>;
    /**
     * 
     * @type {IEmployeeInfoAggregatorDto}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    employee_info?: IEmployeeInfoAggregatorDto;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoAggregatorResponseDto
     * @deprecated
     */
    organization_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    employer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    provider_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    partner_name?: string;
    /**
     * 
     * @type {Array<IClaimPostingInfoDto>}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    postings?: Array<IClaimPostingInfoDto>;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    external_identifier?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    is_escalated?: boolean;
    /**
     * 
     * @type {IClaimEscalationNoteResponseDto}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    claim_escalation_note?: IClaimEscalationNoteResponseDto;
    /**
     * 
     * @type {Array<IClaimTransferInfoDto>}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    claim_transfers?: Array<IClaimTransferInfoDto>;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    source?: IClaimInfoAggregatorResponseDtoSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    card_processor_approved_amount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    is_runout_overridden?: boolean;
    /**
     * 
     * @type {IClaimActorAggregatorDto}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    runout_overridden_by?: IClaimActorAggregatorDto;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    employee_notes?: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    apply_deductible_amount?: number;
    /**
     * 
     * @type {Array<IOrganizationClaimNoteDto>}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    org_path_hierarchy_organizations_claim_notes?: Array<IOrganizationClaimNoteDto>;
    /**
     * 
     * @type {Array<ILetterOfMedicalNecessityDto>}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    letter_of_medical_necessities?: Array<ILetterOfMedicalNecessityDto>;
    /**
     * 
     * @type {IClaimAppealDto}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    claim_appeal?: IClaimAppealDto;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    current_claim_status?: IClaimInfoAggregatorResponseDtoCurrentClaimStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    current_claim_approval_status?: IClaimInfoAggregatorResponseDtoCurrentClaimApprovalStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    claim_approval_status_codes?: Array<IClaimInfoAggregatorResponseDtoClaimApprovalStatusCodesEnum>;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    approval_status_additional_comments?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    current_processing_status_type?: IClaimInfoAggregatorResponseDtoCurrentProcessingStatusTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    current_processing_substatus_type?: IClaimInfoAggregatorResponseDtoCurrentProcessingSubstatusTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    initially_processed_incorrectly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    is_transfer_needed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimInfoAggregatorResponseDto
     */
    is_organization_locked?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IClaimInfoAggregatorResponseDtoPaymentTypeEnum {
    REIMBURSEMENT = 'REIMBURSEMENT',
    BILL_PAY = 'BILL_PAY',
    CARD_SWIPE = 'CARD_SWIPE'
}
/**
* @export
* @enum {string}
*/
export enum IClaimInfoAggregatorResponseDtoSourceEnum {
    WEBSITE = 'WEBSITE',
    CLAIM_PROCESSOR = 'CLAIM_PROCESSOR',
    MOBILE_APP = 'MOBILE_APP',
    ADMIN_PORTAL = 'ADMIN_PORTAL',
    FILE = 'FILE',
    PAYMENT_CARD_TRX = 'PAYMENT_CARD_TRX'
}
/**
* @export
* @enum {string}
*/
export enum IClaimInfoAggregatorResponseDtoCurrentClaimStatusEnum {
    PROCESSING = 'PROCESSING',
    NEEDS_HELP = 'NEEDS_HELP',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PENDING = 'PENDING',
    REPAID = 'REPAID',
    DENIED = 'DENIED',
    DECLINED = 'DECLINED',
    REPROCESSING = 'REPROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    CANCELLED = 'CANCELLED',
    APPLIED_TO_DEDUCTIBLE = 'APPLIED_TO_DEDUCTIBLE',
    OUT_OF_POCKET = 'OUT_OF_POCKET',
    COMPLETE = 'COMPLETE',
    VOIDED = 'VOIDED',
    PAID_INELIGIBLE_EXPENSE = 'PAID_INELIGIBLE_EXPENSE',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}
/**
* @export
* @enum {string}
*/
export enum IClaimInfoAggregatorResponseDtoCurrentClaimApprovalStatusEnum {
    PENDING_REVIEW = 'PENDING_REVIEW',
    UNDER_REVIEW = 'UNDER_REVIEW',
    DOCS_NEEDED = 'DOCS_NEEDED',
    INCOMPLETE = 'INCOMPLETE',
    PARTIALLY_APPROVED = 'PARTIALLY_APPROVED',
    APPROVED = 'APPROVED',
    DENIED = 'DENIED',
    CANCELLED = 'CANCELLED',
    VOIDED = 'VOIDED'
}
/**
* @export
* @enum {string}
*/
export enum IClaimInfoAggregatorResponseDtoClaimApprovalStatusCodesEnum {
    EXPENSE_NOT_ELIGIBLE_PER_IRS_RULES = 'EXPENSE_NOT_ELIGIBLE_PER_IRS_RULES',
    EXPENSE_NOT_ELIGIBLE_PER_PLAN_RULES = 'EXPENSE_NOT_ELIGIBLE_PER_PLAN_RULES',
    SERVICE_DATE_OUTSIDE_OF_COVERAGE_PERIOD = 'SERVICE_DATE_OUTSIDE_OF_COVERAGE_PERIOD',
    CLAIM_RECEIVED_AFTER_RUNOUT_DATE = 'CLAIM_RECEIVED_AFTER_RUNOUT_DATE',
    CLAIM_SUBMITTED_AFTER_GRACE_PERIOD = 'CLAIM_SUBMITTED_AFTER_GRACE_PERIOD',
    DUPLICATE_CLAIM = 'DUPLICATE_CLAIM',
    PROOF_OF_EXPENSE_NEEDED = 'PROOF_OF_EXPENSE_NEEDED',
    LETTER_OF_MEDICAL_NECESSITY_REQUIRED = 'LETTER_OF_MEDICAL_NECESSITY_REQUIRED',
    DETAILED_RECEIPT_REQUIRED = 'DETAILED_RECEIPT_REQUIRED',
    ADDITIONAL_DOCUMENTATION_NEEDED_TO_SUBSTANTIATE_TRANSACTION = 'ADDITIONAL_DOCUMENTATION_NEEDED_TO_SUBSTANTIATE_TRANSACTION',
    ADDITIONAL_COMMENTS = 'ADDITIONAL_COMMENTS',
    CARD_SWIPE_DECLINED_BY_CARD_PROCESSOR = 'CARD_SWIPE_DECLINED_BY_CARD_PROCESSOR',
    AUTOMATICALLY_APPROVED_COPAY_MATCH = 'AUTOMATICALLY_APPROVED_COPAY_MATCH',
    AUTOMATICALLY_APPROVED_NO_RECEIPT_REQUIRED = 'AUTOMATICALLY_APPROVED_NO_RECEIPT_REQUIRED',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_IIAS = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_IIAS',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_COPAY_MATCH = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_COPAY_MATCH',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_TRUSTED_MERCHANT = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_TRUSTED_MERCHANT',
    CLAIM_COULD_NOT_BE_AUTO_SUBSTANTIATED_BY_CARD_PROCESSOR = 'CLAIM_COULD_NOT_BE_AUTO_SUBSTANTIATED_BY_CARD_PROCESSOR',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_CARRIER_CLAIM = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_CARRIER_CLAIM',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_RECURRING_CLAIM = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_RECURRING_CLAIM',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_SUBSTANTIATION_NOT_REQUIRED = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_SUBSTANTIATION_NOT_REQUIRED',
    AUTOMATICALLY_APPROVED_CARRIER_CLAIM = 'AUTOMATICALLY_APPROVED_CARRIER_CLAIM',
    AUTOMATICALLY_APPROVED_AI_RECEIPT_APPROVED = 'AUTOMATICALLY_APPROVED_AI_RECEIPT_APPROVED',
    AUTOMATICALLY_APPROVED_CONTRIBUTION_RETURN_ACCOUNT_CLOSURE = 'AUTOMATICALLY_APPROVED_CONTRIBUTION_RETURN_ACCOUNT_CLOSURE',
    AUTOMATICALLY_APPROVED_BALANCE_RETURN_ACCOUNT_CLOSURE = 'AUTOMATICALLY_APPROVED_BALANCE_RETURN_ACCOUNT_CLOSURE',
    CANNOT_BE_REIMBURSED_FOR_FUTURE_DOS = 'CANNOT_BE_REIMBURSED_FOR_FUTURE_DOS',
    CLAIM_SUBMITTED_AFTER_DEADLINE = 'CLAIM_SUBMITTED_AFTER_DEADLINE',
    MEDICAL_EXPENSE_NOT_ELIGIBLE = 'MEDICAL_EXPENSE_NOT_ELIGIBLE',
    ADDITIONAL_INFO_NEEDED_FOR_PRIOR_BALANCE_DUE = 'ADDITIONAL_INFO_NEEDED_FOR_PRIOR_BALANCE_DUE',
    AMOUNT_NEEDED = 'AMOUNT_NEEDED',
    DATE_OF_SERVICE_NEEDED = 'DATE_OF_SERVICE_NEEDED',
    DATE_RANGE_OF_CARE_NEEDED = 'DATE_RANGE_OF_CARE_NEEDED',
    DOCUMENT_NEEDS_TO_BE_ENGLISH_AND_USD = 'DOCUMENT_NEEDS_TO_BE_ENGLISH_AND_USD',
    DOCUMENT_NOT_READABLE = 'DOCUMENT_NOT_READABLE',
    HANDWRITTEN_RECEIPT_NOT_SUFFICIENT = 'HANDWRITTEN_RECEIPT_NOT_SUFFICIENT',
    MERCHANT_NEEDED = 'MERCHANT_NEEDED',
    SERVICE_DESCRIPTION_NEEDED = 'SERVICE_DESCRIPTION_NEEDED',
    SERVICE_FOR_NEEDED = 'SERVICE_FOR_NEEDED',
    AUTOMATICALLY_APPROVED_RECURRING_CARD_SWIPE = 'AUTOMATICALLY_APPROVED_RECURRING_CARD_SWIPE',
    CUSTOM = 'CUSTOM',
    AUTOMATICALLY_APPROVED_BY_SIGIS = 'AUTOMATICALLY_APPROVED_BY_SIGIS',
    AUTOMATICALLY_APPROVED_EXCESS_CONTRIBUTION_REQUEST = 'AUTOMATICALLY_APPROVED_EXCESS_CONTRIBUTION_REQUEST',
    APPEAL_NOTE = 'APPEAL_NOTE'
}
/**
* @export
* @enum {string}
*/
export enum IClaimInfoAggregatorResponseDtoCurrentProcessingStatusTypeEnum {
    SUBMITTED = 'SUBMITTED',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    PROCESSING = 'PROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAID = 'REPAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    AUTHORIZED = 'AUTHORIZED',
    DECLINED = 'DECLINED',
    EXPIRED = 'EXPIRED',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    DEDUCTIBLE_TRACKING = 'DEDUCTIBLE_TRACKING',
    ACTION_REQUIRED = 'ACTION_REQUIRED',
    STOP_PROCESSING = 'STOP_PROCESSING',
    VOIDED = 'VOIDED',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}
/**
* @export
* @enum {string}
*/
export enum IClaimInfoAggregatorResponseDtoCurrentProcessingSubstatusTypeEnum {
    DOCS_NEEDED = 'DOCS_NEEDED',
    CARRIER_CLAIM = 'CARRIER_CLAIM',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PAYMENT_REJECTED = 'PAYMENT_REJECTED',
    REPAYMENT_REJECTED = 'REPAYMENT_REJECTED',
    PARTIAL_REPAYMENT = 'PARTIAL_REPAYMENT',
    FULL_REPAYMENT = 'FULL_REPAYMENT',
    PARTIAL_PAYMENT = 'PARTIAL_PAYMENT'
}


/**
 * Check if a given object implements the IClaimInfoAggregatorResponseDto interface.
 */
export function instanceOfIClaimInfoAggregatorResponseDto(value: object): value is IClaimInfoAggregatorResponseDto {
    return true;
}

export function IClaimInfoAggregatorResponseDtoFromJSON(json: any): IClaimInfoAggregatorResponseDto {
    return IClaimInfoAggregatorResponseDtoFromJSONTyped(json, false);
}

export function IClaimInfoAggregatorResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimInfoAggregatorResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'payment_type': json['payment_type'] == null ? undefined : json['payment_type'],
        'service': json['service'] == null ? undefined : IServiceDtoFromJSON(json['service']),
        'ocr_details': json['ocr_details'] == null ? undefined : IOcrDetailsDtoFromJSON(json['ocr_details']),
        'claim_status_dtos': json['claim_status_dtos'] == null ? undefined : ((json['claim_status_dtos'] as Array<any>).map(IClaimStatusDtoFromJSON)),
        'claim_approval_status_dtos': json['claim_approval_status_dtos'] == null ? undefined : ((json['claim_approval_status_dtos'] as Array<any>).map(IClaimApprovalStatusAggregatorDtoFromJSON)),
        'claim_processing_status_dtos': json['claim_processing_status_dtos'] == null ? undefined : ((json['claim_processing_status_dtos'] as Array<any>).map(IClaimProcessingStatusDtoFromJSON)),
        'requested_amount': json['requested_amount'] == null ? undefined : json['requested_amount'],
        'approved_amount': json['approved_amount'] == null ? undefined : json['approved_amount'],
        'service_on': json['service_on'] == null ? undefined : (new Date(json['service_on'])),
        'local_date_service_on': json['local_date_service_on'] == null ? undefined : (new Date(json['local_date_service_on'])),
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'created_by': json['created_by'] == null ? undefined : IClaimActorAggregatorDtoFromJSON(json['created_by']),
        'service_for': json['service_for'] == null ? undefined : IClaimActorAggregatorDtoFromJSON(json['service_for']),
        'assignee': json['assignee'] == null ? undefined : IClaimActorAggregatorDtoFromJSON(json['assignee']),
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'document_id': json['document_id'] == null ? undefined : json['document_id'],
        'claim_internal_notes': json['claim_internal_notes'] == null ? undefined : ((json['claim_internal_notes'] as Array<any>).map(IClaimInternalNoteResponseDtoFromJSON)),
        'employee_info': json['employee_info'] == null ? undefined : IEmployeeInfoAggregatorDtoFromJSON(json['employee_info']),
        'organization_name': json['organization_name'] == null ? undefined : json['organization_name'],
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'provider_name': json['provider_name'] == null ? undefined : json['provider_name'],
        'partner_name': json['partner_name'] == null ? undefined : json['partner_name'],
        'postings': json['postings'] == null ? undefined : ((json['postings'] as Array<any>).map(IClaimPostingInfoDtoFromJSON)),
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
        'is_escalated': json['is_escalated'] == null ? undefined : json['is_escalated'],
        'claim_escalation_note': json['claim_escalation_note'] == null ? undefined : IClaimEscalationNoteResponseDtoFromJSON(json['claim_escalation_note']),
        'claim_transfers': json['claim_transfers'] == null ? undefined : ((json['claim_transfers'] as Array<any>).map(IClaimTransferInfoDtoFromJSON)),
        'source': json['source'] == null ? undefined : json['source'],
        'card_processor_approved_amount': json['card_processor_approved_amount'] == null ? undefined : json['card_processor_approved_amount'],
        'is_runout_overridden': json['is_runout_overridden'] == null ? undefined : json['is_runout_overridden'],
        'runout_overridden_by': json['runout_overridden_by'] == null ? undefined : IClaimActorAggregatorDtoFromJSON(json['runout_overridden_by']),
        'employee_notes': json['employee_notes'] == null ? undefined : json['employee_notes'],
        'apply_deductible_amount': json['apply_deductible_amount'] == null ? undefined : json['apply_deductible_amount'],
        'org_path_hierarchy_organizations_claim_notes': json['org_path_hierarchy_organizations_claim_notes'] == null ? undefined : ((json['org_path_hierarchy_organizations_claim_notes'] as Array<any>).map(IOrganizationClaimNoteDtoFromJSON)),
        'letter_of_medical_necessities': json['letter_of_medical_necessities'] == null ? undefined : ((json['letter_of_medical_necessities'] as Array<any>).map(ILetterOfMedicalNecessityDtoFromJSON)),
        'claim_appeal': json['claim_appeal'] == null ? undefined : IClaimAppealDtoFromJSON(json['claim_appeal']),
        'current_claim_status': json['current_claim_status'] == null ? undefined : json['current_claim_status'],
        'current_claim_approval_status': json['current_claim_approval_status'] == null ? undefined : json['current_claim_approval_status'],
        'claim_approval_status_codes': json['claim_approval_status_codes'] == null ? undefined : json['claim_approval_status_codes'],
        'approval_status_additional_comments': json['approval_status_additional_comments'] == null ? undefined : json['approval_status_additional_comments'],
        'current_processing_status_type': json['current_processing_status_type'] == null ? undefined : json['current_processing_status_type'],
        'current_processing_substatus_type': json['current_processing_substatus_type'] == null ? undefined : json['current_processing_substatus_type'],
        'initially_processed_incorrectly': json['initially_processed_incorrectly'] == null ? undefined : json['initially_processed_incorrectly'],
        'is_transfer_needed': json['is_transfer_needed'] == null ? undefined : json['is_transfer_needed'],
        'is_organization_locked': json['is_organization_locked'] == null ? undefined : json['is_organization_locked'],
    };
}

export function IClaimInfoAggregatorResponseDtoToJSON(json: any): IClaimInfoAggregatorResponseDto {
    return IClaimInfoAggregatorResponseDtoToJSONTyped(json, false);
}

export function IClaimInfoAggregatorResponseDtoToJSONTyped(value?: IClaimInfoAggregatorResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organization_id': value['organization_id'],
        'payment_type': value['payment_type'],
        'service': IServiceDtoToJSON(value['service']),
        'ocr_details': IOcrDetailsDtoToJSON(value['ocr_details']),
        'claim_status_dtos': value['claim_status_dtos'] == null ? undefined : ((value['claim_status_dtos'] as Array<any>).map(IClaimStatusDtoToJSON)),
        'claim_approval_status_dtos': value['claim_approval_status_dtos'] == null ? undefined : ((value['claim_approval_status_dtos'] as Array<any>).map(IClaimApprovalStatusAggregatorDtoToJSON)),
        'claim_processing_status_dtos': value['claim_processing_status_dtos'] == null ? undefined : ((value['claim_processing_status_dtos'] as Array<any>).map(IClaimProcessingStatusDtoToJSON)),
        'requested_amount': value['requested_amount'],
        'approved_amount': value['approved_amount'],
        'service_on': value['service_on'] == null ? undefined : ((value['service_on']).toISOString()),
        'local_date_service_on': value['local_date_service_on'] == null ? undefined : ((value['local_date_service_on']).toISOString().substring(0,10)),
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'created_by': IClaimActorAggregatorDtoToJSON(value['created_by']),
        'service_for': IClaimActorAggregatorDtoToJSON(value['service_for']),
        'assignee': IClaimActorAggregatorDtoToJSON(value['assignee']),
        'organization_path': value['organization_path'],
        'document_id': value['document_id'],
        'claim_internal_notes': value['claim_internal_notes'] == null ? undefined : ((value['claim_internal_notes'] as Array<any>).map(IClaimInternalNoteResponseDtoToJSON)),
        'employee_info': IEmployeeInfoAggregatorDtoToJSON(value['employee_info']),
        'organization_name': value['organization_name'],
        'employer_name': value['employer_name'],
        'subsidiary_name': value['subsidiary_name'],
        'provider_name': value['provider_name'],
        'partner_name': value['partner_name'],
        'postings': value['postings'] == null ? undefined : ((value['postings'] as Array<any>).map(IClaimPostingInfoDtoToJSON)),
        'external_identifier': value['external_identifier'],
        'is_escalated': value['is_escalated'],
        'claim_escalation_note': IClaimEscalationNoteResponseDtoToJSON(value['claim_escalation_note']),
        'claim_transfers': value['claim_transfers'] == null ? undefined : ((value['claim_transfers'] as Array<any>).map(IClaimTransferInfoDtoToJSON)),
        'source': value['source'],
        'card_processor_approved_amount': value['card_processor_approved_amount'],
        'is_runout_overridden': value['is_runout_overridden'],
        'runout_overridden_by': IClaimActorAggregatorDtoToJSON(value['runout_overridden_by']),
        'employee_notes': value['employee_notes'],
        'apply_deductible_amount': value['apply_deductible_amount'],
        'org_path_hierarchy_organizations_claim_notes': value['org_path_hierarchy_organizations_claim_notes'] == null ? undefined : ((value['org_path_hierarchy_organizations_claim_notes'] as Array<any>).map(IOrganizationClaimNoteDtoToJSON)),
        'letter_of_medical_necessities': value['letter_of_medical_necessities'] == null ? undefined : ((value['letter_of_medical_necessities'] as Array<any>).map(ILetterOfMedicalNecessityDtoToJSON)),
        'claim_appeal': IClaimAppealDtoToJSON(value['claim_appeal']),
        'current_claim_status': value['current_claim_status'],
        'current_claim_approval_status': value['current_claim_approval_status'],
        'claim_approval_status_codes': value['claim_approval_status_codes'],
        'approval_status_additional_comments': value['approval_status_additional_comments'],
        'current_processing_status_type': value['current_processing_status_type'],
        'current_processing_substatus_type': value['current_processing_substatus_type'],
        'initially_processed_incorrectly': value['initially_processed_incorrectly'],
        'is_transfer_needed': value['is_transfer_needed'],
        'is_organization_locked': value['is_organization_locked'],
    };
}

